module.exports = __webpack_public_path__ + "img/checked2.15d61e02.png";